// extracted by mini-css-extract-plugin
module.exports = {"grid-cell":"StoryblokGridCell_grid-cell__Stj1h","grid-cell_children-full-height":"StoryblokGridCell_grid-cell_children-full-height__8i14u"};